import axiosInstance from "../services/secureApi";

export const getOrderByIdApi = async (orderId) => {
  try {
    const response = await axiosInstance.get(`/orders/${orderId}`);
    return response.data;
  } catch (error) {
    console.error("Get Order Error:", error.response?.data);
    throw error.response?.data || error;
  }
};